module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_Area_de_Lazer.eccd9d08.jpg";